import '~/js/modules/common';
import '~/pug/blocks/plainform/plain-form.js';
import ImageFullscreen from '~/js/modules/image-fullscreen';
import getSwiperSlider from '~/js/modules/slider';

const sliderImageClickHandler = e => new ImageFullscreen(e.currentTarget);

document.addEventListener(`DOMContentLoaded`, () => {
  const projectThumbsSlider = document.querySelector(`.js-project-complete-swiper`);

  let projectThumbsSwiper;
  const projectThumbsSwiperParams = {
    slidesPerView: `auto`,
    allowTouchMove: false,
    centerInsufficientSlides: true,
    speed: 0,
    navigation: {
      nextEl: `.swiper-button-next`,
      prevEl: `.swiper-button-prev`,
    },
    on: {
      init() {
        const images = this.el.querySelectorAll(`.project-component-page__info-thumb`);

        if (images.length) {
          images.forEach(image => {
            image.addEventListener(`click`, sliderImageClickHandler);
          });
        }
      },
    },
  };

  if (projectThumbsSlider) {
    projectThumbsSwiper = getSwiperSlider(projectThumbsSlider, projectThumbsSwiperParams);
  }
});
